enum Actions {
  VIEW = 'view',
  DOWNLOAD = 'download',
  DELETE = 'delete',
  DUPLICATE = 'duplicate',
}

export default Actions;
